<template>
    <div class="watch-list">        
        <article v-for="item in streams" :key="item.id">
            <a :href="item.data.stream_url" target="_blank">
                <h3>{{ item.title }}</h3>
                <span class="right">
                    Watch <span class="material-icons">chevron_right</span>
                </span>
            </a>
        </article>           
        
        <button v-if="next" type="button" class="button" @click="loadMore">Load more</button>

    </div>
</template>

<script>
export default {
  props: [
    "url"
  ],

  data () {
    return {
      links: [],
      streams: [],
      next: ""
    }
  },

  mounted(){
      axios.get(this.url).then(response => {
        this.streams = response.data.data
        this.next = response.data.links.next
      })
  },

  methods: {
    loadMore () {
      axios.get(this.next).then(response => {
        this.streams = this.streams.concat(response.data.data)
        this.next = response.data.links.next
      })
    },
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Streams.vue